import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Card, Form, Space, Spin } from "antd";
import { unwrapResult } from "@reduxjs/toolkit";
import { message } from "components";
import { RootState, useAppDispatch } from "app/store";
import AccessControlForm, { AccessControlFormProps } from "../AccessControlForm";
import { createEmailDomain } from "../accessControlSlice";

function AccessControlCreation() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const isLoading = useSelector((state: RootState) => state.loading);

  function goBackToList() {
    history.push("/customers/access-control");
  }

  const handleSubmit: AccessControlFormProps["onFinish"] = (values) => {
    dispatch(createEmailDomain(values)).then(unwrapResult).then(goBackToList).catch(message.error);
  };

  const cardExtra = (
    <Space>
      <Button type="default" shape="round" onClick={goBackToList}>
        Cancel
      </Button>
      <Button type="primary" shape="round" onClick={form.submit}>
        Save
      </Button>
    </Space>
  );

  return (
    <Card title="Add domain" extra={cardExtra} className="page-container">
      <Spin spinning={isLoading} size="large">
        <AccessControlForm form={form} data={{ blockRegistration: true, blockLogin: true }} onFinish={handleSubmit} />
      </Spin>
    </Card>
  );
}

export default AccessControlCreation;
